
import genomeSidebar            from './genomeSidebar';
import React                    from 'react';
import ReactHelper              from '_utils/ReactHelper';
import SearchBarController      from '_controllers/SearchBarController';
import searchResultsTracker     from '../../shared/searchResultsTracker';
import VideoModalPoster         from '_views/shared/VideoModalPoster'

let genomePageSearchButton, genomePageElem, searchBarControllerDock, videoModalPoster;

const genomePage = {

  init() {
    /*
    ==================================================
     INIT SUB-MODULES
    ==================================================
    */

    genomeSidebar.init();
    searchResultsTracker.init();


    /*
    ==================================================
     CACHE DOM ELEMENTS
    ==================================================
    */

    genomePageSearchButton = document.querySelector('#genome-page-search-button');
    genomePageElem = document.querySelector('.genome-page');
    searchBarControllerDock = document.querySelector('.search-bar-controller-dock');
    videoModalPoster = document.querySelector('#video-modal-poster');


    /*
    ==================================================
     RENDER REACT COMPONENTS
    ==================================================
    */

    if (videoModalPoster) {
      ReactHelper.renderComponent(<VideoModalPoster />, '#video-modal-poster');
    }


    /*
    ==================================================
     WIRE DOM ELEMENTS
    ==================================================
    */

    if (genomePageSearchButton) {
      genomePageSearchButton.addEventListener('click', genomePage.handleGenomePageSearchButtonClick);
    }
  },


  /*
  ==================================================
   EVENT HANDLERS
  ==================================================
  */

  handleGenomePageSearchButtonClick: (e) => {
    e.preventDefault();

    genomePageElem.classList.add('search-bar-open');

    if (searchBarControllerDock) {
      ReactHelper.renderComponent(
        <SearchBarController
          domain="genome"
          hasCloseButton={true}
          onCloseRequest={genomePage.handleCloseRequest}
        />, '.search-bar-controller-dock');
    }
  },

  handleCloseRequest: () => {
    genomePageElem.classList.remove('search-bar-open');

    if (searchBarControllerDock) {
      ReactHelper.removeComponent('.search-bar-controller-dock');
    }
  },

  /*
  ==================================================
   LOCAL UTILS
  ==================================================
  */

}

export default genomePage;
